import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { cdpClient } from '../client';
import { activeProjectId } from '../projectScope';
import type { components } from '../generated/schema';
import type { Postback } from '../types';

export interface PostbackListFilters {
  phone?: string | null;
  click_id?: string | null;
  goal?: string | null;
  start_date?: string | null;
  end_date?: string | null;
}

const filters: PostbackListFilters = {};

export function setPostbackListFilters(next: PostbackListFilters): void {
  Object.assign(filters, next);
}

function withEventId(
  items: components['schemas']['PostbackResponse'][],
): Postback[] {
  return items.map((row) => ({
    ...row,
    id: row.event_id ?? `${row.phone}-${row.goal}-${row.created_at}`,
  }));
}

export const postbacksAdapter: CrudAdapter<Postback, never, never> = {
  async list({ offset, limit }) {
    const query = {
      limit,
      offset,
      phone: filters.phone ?? undefined,
      click_id: filters.click_id ?? undefined,
      goal: filters.goal ?? undefined,
      start_date: filters.start_date ?? undefined,
      end_date: filters.end_date ?? undefined,
      project_id: activeProjectId.value ?? undefined,
    };
    const { data, error } = await cdpClient.GET('/postbacks', {
      params: { query: query as never },
    });
    if (error) throw error;
    return {
      items: withEventId(data?.items ?? []),
      total: data?.total ?? 0,
    };
  },
};

export const postbacksStore = useCrudDataSource(postbacksAdapter, { keyExpr: 'id' });
